"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PossessAbilityHandler = exports.PossessActorAbilityFactory = exports.PossessAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
class PossessAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Possess;
        this.__typeName = "Possess";
    }
}
exports.PossessAbilityArgs = PossessAbilityArgs;
let PossessActorAbilityFactory = class PossessActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Possess", "OneEnemies", 0);
    }
};
PossessActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Possess")
], PossessActorAbilityFactory);
exports.PossessActorAbilityFactory = PossessActorAbilityFactory;
let PossessAbilityHandler = class PossessAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyDebuff({
            sequence,
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            effect: new __1.PossessedEffectArgs(),
            duration: Duration_1.Duration.Permanent,
            onApplied: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(selectedEnemy, "feet"), "EngulfingDarkness"));
            }
        });
    }
};
PossessAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Possess)
], PossessAbilityHandler);
exports.PossessAbilityHandler = PossessAbilityHandler;
